import { render, staticRenderFns } from "./block-template-share.vue?vue&type=template&id=e662bdc8&scoped=true&lang=pug"
import script from "./block-template-share.vue?vue&type=script&lang=js"
export * from "./block-template-share.vue?vue&type=script&lang=js"
import style0 from "./block-template-share.vue?vue&type=style&index=0&id=e662bdc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e662bdc8",
  null
  
)

export default component.exports